<template lang="pug">
  section.modal(
    :class="{ send: form.successSend }"
  )
    button.modal__close-btn-big(@click="closeModal") Закрыть окно
    .modal__content.bg-white
      button.modal__close-btn(@click="closeModal") Закрыть окно

      h2.modal__title.t-h2 {{ title }}

      form.modal__form(
        @submit.prevent="onFormSubmit"
        ref="feedBackForm"
        action=`https://www.euromobile.ru/ajax/form_submit.php`
        method=`post`
      )
        base-input(
          v-for="el in form.inputs"
          :key="el.id"
          :tagName="el.tagName"
          :class="el.inputClass"
          :type="el.type"
          :id="el.id"
          :name="el.name"
          :pattern="el.pattern"
          :required="el.required"
          :labelText="el.labelText"
        )

        base-input(
          :tagName="form.textarea.tagName"
          :class="form.textarea.inputClass"
          :id="form.textarea.id"
          :name="form.textarea.name"
          :required="form.textarea.required"
          :labelText="form.textarea.labelText"
        )

        .modal__submit
          base-input(
            :class="form.checkbox.inputClass"
            :type="form.checkbox.type"
            :id="form.checkbox.id"
            :name="form.checkbox.name"
            :required="form.checkbox.required"
            :labelText="form.checkbox.labelText"
          )
            a.t-tdn(
              href=`https://em-engin.ru/politika-konfidentsialnosti/`
              target=`_blank`
            ) Политикой конфиденциальности
            span.input__label-checkbox.bg-white
              svg(xmlns=`http://www.w3.org/2000/svg`)
                use(:href="$setSvgHref(`img/sprite.svg#i-tick`)")

          base-button(
            :btnClass="button.btnClass"
            :btnType="button.btnType"
            :btnText="button.btnText"
            :btnStyle="button.btnStyle"
            @click.native="sendInfoToMetrika"
          )

      form.modal__form-success.t-h2 Спасибо, ваша заявка отправлена!

</template>

<script>

export default {
  props: {
    title: String
  },
  data () {
    return {
      form: {
        inputs: [{
          inputClass: `input--dark modal__input modal__input--name`,
          id: `orderName`,
          name: `form[form_text_113]`,
          required: true,
          labelText: `ФИО*`
        }, {
          inputClass: `input--dark modal__input modal__input--tel`,
          type: `tel`,
          id: `orderTel`,
          name: `form[form_text_114]`,
          pattern: `\\+[0-9]{1}\\([0-9]{3}\\)[0-9]{3}-[0-9]{2}-[0-9]{2}`,
          required: true,
          labelText: `Контактный телефон*`
        }, {
          inputClass: `input--dark modal__input modal__input--email`,
          type: `email`,
          id: `orderEmail`,
          name: `form[form_text_115]`,
          required: true,
          labelText: `E-mail*`
        }],
        textarea: {
          inputClass: `input--dark modal__input modal__input--textarea`,
          tagName: `textarea`,
          id: `orderQuestion`,
          name: `form[form_text_116]`,
          required: false,
          labelText: `Комментарий`
        },
        checkbox: {
          inputClass: `input--dark modal__input modal__input--checkbox`,
          type: `checkbox`,
          id: `orderConfirmation`,
          name: `orderConfirmation`,
          required: true,
          labelText: `Я согласен с `
        },
        successSend: false
      },
      button: {
        btnClass: `btn--fill modal__submit-btn`,
        btnType: `submit`,
        btnText: `Отправить заявку`,
        btnStyle: {
          color: `#5182dd`
        }
      }
    }
  },
  created: function () {
  },
  methods: {
    closeModal () {
      this.$store.dispatch(`hideModal`)
      this.form.successSend = false
    },
    sendInfoToMetrika () {
      window.ym(56339290, 'reachGoal', 'otrp_zayavk')
    },
    async onFormSubmit () {
      const formData = new FormData(this.$refs.feedBackForm)
      let recaptchaPromise
      let $this

      $this = this
      formData.append(`form_id`, `16`)

      formData.append(`form_id`, `16`)

      window.grecaptcha.ready(() => {
        recaptchaPromise = window.grecaptcha.execute('6LcRJhwgAAAAAH6Jv4BTs5vhBcL1IJgWhA4URoA6', { action: 'homepage' })
        recaptchaPromise.then(async function (token) {
          formData.append('recaptcha_token', token)

          const response = await fetch('https://www.euromobile.ru/ajax/form_submit.php', {
            method: 'POST',
            body: formData
          })

          if (response.ok) {
            const result = await response.json()

            if (result.success) {
              $this.$refs.feedBackForm.reset()
              $this.form.successSend = true
              console.log(result)
            }
            window.ym(56339290, 'reachGoal', 'otprFormi_zayavk')
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal {
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transition: $trs;
    pointer-events: none;

    &.show {
      opacity: 1;
      pointer-events: all;
    }

    /deep/ .input__element {
      font-size: 1rem;
    }

    /deep/ .input__label {
      font-size: 1rem;
      background-color: $white;

      a {
        font-size: 1rem;
      }
    }
  }

  .modal__close-btn-big {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background-color: $grey;
    opacity: 0.5;
  }

  .modal__content {
    overflow: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    min-width: 38vw;
    max-height: 85vh;
    padding-top: 4rem;
    padding-bottom: 3.5rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    border-radius: 1.5rem;
    box-shadow: 0px 16px 16px rgba(26, 32, 59, 0.16);
    transform: translate(-50%, -50%);

    @include respond-max(tablet) {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      min-width: auto;
      max-height: none;
      border-radius: 0;
      transform: none;
      box-shadow: none;
    }
  }

  .modal__close-btn {
    position: absolute;
    top: 0.875rem;
    right: 0.875rem;
    width: 2.125rem;
    height: 2.125rem;
    padding: 0.5rem;
    font-size: 0;
    border: 0;
    background-color: transparent;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1px;
      height: 1.125rem;
      background-color: $black;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .modal__title {
    margin-bottom: 2.625rem;
  }

  .modal__form {
    opacity: 1;
    transition: $trs;

    .modal.send & {
      opacity: 0;
    }
  }

  .modal__form-success {
    position: absolute;
    top: 50%;
    left: 2.5rem;
    right: 2.5rem;
    text-align: center;
    opacity: 0;
    transform: translateY(-50%);
    transition: $trs;
    pointer-events: none;

    .modal.send & {
      opacity: 1;
      pointer-events: all;
    }
  }

  .modal__input {
    margin-bottom: 1.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &--textarea {
      /deep/ textarea {
        min-height: 9.3625rem;
      }
    }
  }

  .modal__submit {
    display: flex;
    align-items: center;
    margin-top: 1rem;

    @include respond-max(tablet) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .modal__submit-btn {
    min-width: 16rem;

    @include respond-max(tablet) {
      margin-top: 1rem;
    }
  }
</style>
